<template>
	<div>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<Navbar :name="name"
			:editable="true"
			:setProjectName="this.sendProjectName"
			:oldName="this.oldName"
			:setHelp="this.setHelp"
			:helpState="helpState"
			:helpButtonText="helpButtonText" />
		<keep-alive>
			<StepsCarousel :steps="steps"
				:setComponent="this.setComponent"
				:active_el="activeStep" />
		</keep-alive>
		<!--		<RenderSelector v-if="this.thematicId == 'interview'" :value="this.project_render" />-->
		<b-container>
			<keep-alive>
				<router-view :helpState="helpState">
				</router-view>
				<component v-bind:is="component"
					v-bind="steps[activeStep]"
					:key="activeStep"
					:stepOrder="activeStep"
					:helpState="helpState"
					ref="stepComponent" />
			</keep-alive>
		</b-container>
	</div>
</template>

<script>
import StepTitle from "../steps/Title";
import StepAmbiance from "../steps/Ambiance";
import StepAmbiance_old from "../steps/Ambiance_old";
import StepMusic from "../steps/Music";
import StepSpeech from "../steps/Speech";
import StepKeynumber from "../steps/KeyNumber";
import Final from "../steps/Final";
import StepsCarousel from "../carousels/StepsCarousel";
import StepWatermark from "../steps/Watermark";
import StepVideo from "../steps/Video";
import StepPartners from "../steps/Partners";
import StepImages from "../steps/Images";
import StepInfographic from "../steps/Infographic";
import StepDetail from "../steps/Detail";
import Navbar from "../ui/Navbar";
// import RenderSelector from "../ui/RenderSelector";
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ProjectEdition",
	components: {
		lottie_error,
		Navbar,
		// RenderSelector,
		StepsCarousel,
		StepTitle,
		StepMusic,
		StepKeynumber,
		Final,
		StepAmbiance,
		StepAmbiance_old,
		StepSpeech,
		StepVideo,
		StepPartners,
		StepImages,
		StepWatermark,
		StepDetail,
		StepInfographic,
	},
	data() {
		return {
			component: null,
			active_el: 0,
			steps: [],
			text_error: "",
			helpState: true,
			projectName: "",
			project_render: "",
			thematicId: "",
			helpButtonText: "Désactiver l'aide au survol",
		};
	},
	computed: {
		name: {
			get() {
				return this.projectName;
			},
			set(v) {
				this.projectName = v;
			},
		},
		activeStep: {
			get() {
				return this.active_el;
			},
			set(v) {
				this.active_el = v;
			},
		},
		oldName: {
			get() {
				return this.projectName;
			},
			set(v) {
				this.projectName = v;
			},
		},
	},
	beforeMount() {
		let $this = this;
		axios
		.get(BASE_URL + "/public/api/projects/" + $this.$route.params.id + "/visiblesSteps",
			{
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
		.then(function (response) {
			$this.thematicId = response.data.project.data.thematicId;
			let data = response.data.project.data.steps;
			for (let i = 0; i <= data.length - 1; i++) {
				if (data[i].type !== undefined) {
					data[i].disabled = false;
					$this.steps.push(data[i]);
				}
			}
			$this.steps.push({
				stepName: "Finalise",
				stepOrder: 99,
				type: "Final",
			});

			if($this.steps[0].groupId.substring(2) === "Title") {
				// $this.setComponent($this.steps[0].type.substr(4), 0);
				$this.setComponent("StepAmbiance_old", 0);
			}
			else {
				$this.setComponent($this.steps[0].type.substr(4), 0);
			}
		})
		.catch(error => {
			this.text_error = this.$root.$t("Errors.message_project") + error;
			this.$refs.modalError.show();
		});

		// What the hell is this next call
		axios.get(BASE_URL + "/public/api/projects/" + $this.$route.params.id, {
			headers: {
				"Authorization": sessionStorage.getItem("auth"),
			},
		})
		.then(function (response) {
			$this.name = response.data.project.data.name;
			$this.project_render = response.data.project.data.render_num;

			if (response.data.project.data.destinationLang !== undefined) {
				sessionStorage.setItem("dest_lang", JSON.stringify(response.data.project.data.destinationLang), function (a, b) {
					if (a.name > b.name) {
						return -1;
					}
					if (a.name < b.name) {
						return 1;
					}
					return 0;
				});
			}
		})
		.catch(error => {
			this.text_error = this.$root.$t("Errors.message_project") + error;
			this.$refs.modalError.show();
		});
	},
	beforeRouteLeave(to, from, next) {
		if (sessionStorage.getItem("dest_lang")) {
			sessionStorage.removeItem("dest_lang");
		}
		next();
	},
	methods: {
		setHelp() {
			this.helpState = !this.helpState;
			if (this.helpState === false) {
				this.helpButtonText = this.$root.$t("Button.enable_tooltip");
				// EventBus.$emit("setHelpText", "Help.enable_tooltip");
			}
			else {
				this.helpButtonText = this.$root.$t("Button.disable_tooltip");
				// EventBus.$emit("setHelpText", "Help.disable_tooltip");
			}
			sessionStorage.setItem("helpState", this.helpState);
		},
		sendProjectName(value) {
			let $this = this;
			let bodyFormData = new FormData();
			bodyFormData.append("name", value);
			bodyFormData.append("_method", "PUT");
			axios.post(BASE_URL + "/public/api/projects/" + $this.$route.params.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function (response) {
				$this.name = response.data.data.name;
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		setComponent(v, i) {
			if (!this.steps[i].disabled) {
				this.component = v;
				this.activeStep = i;
				this.checkStepsEvent();
			}
		},
		checkStepsEvent() {
			let $this = this;

			EventBus.$on("setStepTitleComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepTitle") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepTitleNotComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepTitle") {
						$this.steps[i].isCompleted = false;
						$this.$forceUpdate();
					}
				}
			});

			EventBus.$on("setStepAmbianceComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepAmbiance") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepAmbianceNotComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepAmbiance") {
						$this.steps[i].isCompleted = false;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepInfographicComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepInfographic") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepLogoComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepTitle") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepSpeechComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepSpeech") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepSpeechNotComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepSpeech") {
						$this.steps[i].isCompleted = false;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepImagesComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepImages") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepImagesNotComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepImages") {
						$this.steps[i].isCompleted = false;
						$this.$forceUpdate();
					}
				}
			});

			EventBus.$on("setStepMusicComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepMusic") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepKeynumberComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepKeynumber") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepPartnersComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepPartners") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepDetailComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepDetail") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepVideoComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepVideo") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("setStepWatermarkComplete", id => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if ($this.steps[i].id === id && $this.steps[i].type === "App\\StepWatermark") {
						$this.steps[i].isCompleted = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("lock_steps", options => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					if (!($this.steps[i].id === options.id && $this.steps[i].type === options.type)) {
						$this.steps[i].disabled = true;
						$this.$forceUpdate();
					}
				}
			});
			EventBus.$on("unlock_steps", options => {
				for (let i = 0; i <= $this.steps.length - 1; i++) {
					$this.steps[i].disabled = false;
					$this.$forceUpdate();
				}
			});
		},
	},
};
</script>

<style scoped>

</style>
